import {
  Tile,
  TileImage,
  TileOverlay,
  TileCaption,
  Nameplate,
} from '@mc/design-system'
import Image from 'components/LegacyImage'
import Link from 'components/Link'
import NameplateImage from 'components/NameplateImage'
import { coursePath } from 'libs/paths'
import type { PrunedCourse } from 'libs/utils'

type CourseOverlayStackedTileProps = {
  course: PrunedCourse
}

const CourseOverlayStackedTile = ({
  course,
}: CourseOverlayStackedTileProps) => (
  <div className='mc-p-2'>
    <Link href={coursePath(course.slug)} passHref>
      <Tile aspectRatio='3x4' className='mc-corners--rounded'>
        <TileImage
          className='mc-corners--rounded'
          image={
            <Image
              alt=''
              src={course.primary2x3 ?? ''}
              width={300}
              height={400}
            />
          }
        />
        <TileOverlay className='mc-corners--rounded' />
        <TileCaption position='center bottom'>
          <Nameplate
            size='small'
            image={
              <NameplateImage
                alt={course.instructorName ?? ''}
                src={course.nameplate ?? ''}
                sizes='220px'
              />
            }
          />
        </TileCaption>
      </Tile>
    </Link>
    <p className='mc-text-x-small mc-text--2-lines mc-text--center mc-mt-2'>
      {course.headline}
    </p>
  </div>
)

export default CourseOverlayStackedTile
